import React, { useContext } from "react";
import styles from "./ProgressClubPoints.module.css";
import SettingsContext from "~/contexts/SettingsContext";
import ThemeContext from "~/contexts/ThemeContext";

interface ProgressClubPointsProps {
  currentPoints: number;
}

const ProgressClubPoints: React.FC<ProgressClubPointsProps> = ({
  currentPoints,
}) => {
  const { orgSettings } = useContext(SettingsContext);
  const { template } = useContext(ThemeContext);

  const targetPoints = template.loyaltyDialog.targetPoints.points;
  const pointsToNext = Math.max(targetPoints - currentPoints, 0);

  const progressPercentage = Math.min(
    (currentPoints / targetPoints) * 100,
    100,
  );

  // Styles
  const targetPointsBackgroundColor =
    template.loyaltyDialog.targetPoints.backgroundColour;
  const targetPointsProgressBarColor =
    template.loyaltyDialog.targetPoints.progressBarColour;

  return (
    <div
      className={styles.container}
      style={{ backgroundColor: targetPointsBackgroundColor }}
    >
      <div className={styles.header}>
        <span className={styles.title}>How you’re tracking…</span>
        <span
          className={styles.percentage}
          style={{ color: targetPointsProgressBarColor }}
        >
          {Math.round(progressPercentage)}%
        </span>
      </div>

      <div className={styles.progressBar}>
        <div
          className={styles.progressFill}
          style={{
            width: `${progressPercentage}%`,
            backgroundColor: targetPointsProgressBarColor,
          }}
        />
      </div>

      <div className={styles.footer}>
        <span className={styles.pointsText}>
          <span
            className={styles.pointsNumber}
            style={{ color: targetPointsProgressBarColor }}
          >
            {pointsToNext}
          </span>{" "}
          {orgSettings.loyaltySettings?.balanceUnitName ?? "balance"} away from
          your next reward!
        </span>
      </div>
    </div>
  );
};

export default ProgressClubPoints;
